import { initializeApp } from 'firebase/app';
import { connectDatabaseEmulator, get, getDatabase, onValue, query, ref } from 'firebase/database';
import { __stringify, _keys, exists, filterInstances, ImplementationMissingException, Logger, Module } from '@nu-art/ts-common';
import 'firebase/database';
const MandatoryFirebaseConfigKeys = ['apiKey', 'authDomain', 'databaseURL', 'projectId', 'appId'];
export class ModuleFE_FirebaseListener_Class extends Module {
    app;
    database;
    init() {
        if (!this.config.firebaseConfig)
            throw new ImplementationMissingException('Could not initialize firebase listener, did not provide FE firebase config!');
        const configObjectKeys = _keys(this.config.firebaseConfig);
        const missingKeys = filterInstances(MandatoryFirebaseConfigKeys.map(key => configObjectKeys.includes(key) ? undefined : key));
        if (missingKeys.length > 0)
            throw new ImplementationMissingException(`Could not initialize firebase listener, FE firebase config is missing props: ${__stringify(missingKeys)}`);
        this.app = initializeApp(this.config.firebaseConfig);
    }
    getDatabase() {
        if (this.database)
            return this.database;
        const _database = getDatabase(this.app);
        const emulatorConfig = this.config.emulatorConfig;
        if (exists(emulatorConfig)) {
            connectDatabaseEmulator(_database, emulatorConfig.hostname, emulatorConfig.port);
        }
        return this.database = _database;
    }
    createListener(nodePath) {
        this.logDebug(`Creating listener for firebase rtdb node ${nodePath}`);
        return new RefListenerFE(nodePath);
    }
}
/**
 * Firebase Realtime Database rules need to allow reading the nodes that are being queried.
 * <p>"<b>Permission Denied</b>" errors in dev console imply permission is not allowed in the db's rules.
 */
export class RefListenerFE extends Logger {
    nodePath;
    toUnsubscribeFunction;
    constructor(nodePath) {
        super(`RefListenerFE('${nodePath}')`);
        this.nodePath = nodePath;
    }
    getQuery() {
        const db = ModuleFE_FirebaseListener.getDatabase();
        return query(ref(db, this.nodePath));
    }
    /**
     * Receives initial value and listens henceforth.
     */
    startListening(onValueChangedListener) {
        if (this.toUnsubscribeFunction) {
            this.logWarning('RefListener asked to listen mid-listening. Stopping to listen prior to re-listening');
            this.stopListening();
        }
        this.logDebug('Starting to listen...');
        const refQuery = this.getQuery();
        try {
            this.toUnsubscribeFunction = onValue(refQuery, (snapshot) => {
                onValueChangedListener(snapshot);
            }, error => {
                this.logError('Failed receiving value with error', error);
            });
        }
        catch (e) {
            this.logWarning(`Failed listening on node data, check if your rtdb rules permit reading this node '${this.nodePath}'`);
            throw e;
        }
        this.logDebug(`Listening.`);
        return this;
    }
    /**
     * One time get the value.
     */
    async get() {
        try {
            const dataSnapshot = await get(this.getQuery());
            return dataSnapshot.val();
        }
        catch (e) {
            this.logWarning(`Failed getting node data, check if your rtdb rules permit reading this node '${this.nodePath}'`);
            throw e;
        }
    }
    stopListening() {
        if (!this.toUnsubscribeFunction) {
            this.logWarning('RefListener asked to stop listening but unsubscribeFunction does not exist.');
            return;
        }
        this.logInfo('RefListener asked to stop listening');
        this.toUnsubscribeFunction();
        this.toUnsubscribeFunction = undefined;
    }
}
export const ModuleFE_FirebaseListener = new ModuleFE_FirebaseListener_Class();
//# sourceMappingURL=ModuleFE_FirebaseListener.js.map